import AppLink from '@chegg-wt/core/components/AppLink'
import { Config } from '@chegg-wt/core/config'
import { DISCLAIMER_TEXT } from '@chegg-wt/core-wa/constants/paraphraser'
import { Disclaimer, DisclaimerLink } from './styled'

export const AiPoweredDisclaimer = ({ className }) => {
  return (
    <Disclaimer data-test="wa-editor-footer-disclaimer" className={className}>
      {DISCLAIMER_TEXT}
      <AppLink route={{ href: `${Config.cheggEnvUrl}/termsofuse` }}>
        <DisclaimerLink>terms of use</DisclaimerLink>
      </AppLink>
      {' and '}
      <AppLink route={{ href: `${Config.cheggEnvUrl}/privacypolicy` }}>
        <DisclaimerLink>privacy policy</DisclaimerLink>
      </AppLink>
      .
    </Disclaimer>
  )
}
